import * as React from "react";
function SvgSuitcase(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M37.5 10.5v-9h-27v9H0v36h48v-36H37.5zm-24-6h21v6h-21v-6zM3 13.5h42V21H3v-7.5zM22.5 24h3v3h-3v-3zM3 43.5V24h16.5v6h9v-6H45v19.5H3z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSuitcase);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
